import { type FC } from 'react';

import { useSearchOffersDesktopQuery } from '@/packages/query-state/shared/store/search-offers/v3/search-offers-desktop/query';

import { MarkedList } from './MarkedList';

export const MarkedListContainer: FC = () => {
  const { data: markedList } = useSearchOffersDesktopQuery({ select: data => data.seo.view.markedList });

  if (!markedList?.length) {
    return null;
  }

  return <MarkedList items={markedList} />;
};
